import React from 'react';
import { RACModalCard } from '@rentacenter/racstrap';
import ModalBuilder from './modalBuilder';
import { useTranslation } from 'react-i18next';

const ModalContainer = (props: any): any => {
  const { t } = useTranslation('agreement');
  const radiusProvider = '25px !important';
  return (
    <>
      <RACModalCard
        isOpen={props.throwModalController.addAllPopUp}
        closeIcon={true}
        maxWidth="xs"
        onClose={() =>
          props.throwMethodAssigner.closeModalCaller('addAllPopUp')
        }
        borderRadius={radiusProvider}
      >
        <ModalBuilder
          displayData={t('Do you want to add other items on this Price Tag ?')}
          methodController="package data"
          requiredButton="Pair"
          triggeraddAllItem={props.throwMethodAssigner.addAllItemCaller}
          triggerdeclineAddOther={
            props.throwMethodAssigner.declineAddOtherCaller
          }
        />
      </RACModalCard>

      <RACModalCard
        isOpen={props.throwModalController.breakPopup}
        maxWidth="xs"
        closeIcon={true}
        onClose={() => props.throwMethodAssigner.closeModalCaller('breakPopup')}
        borderRadius={radiusProvider}
      >
        <ModalBuilder
          displayData={t('Do you want to break the Price Tag ?')}
          methodController="break package"
          requiredButton="Pair"
          triggercloseGroupPop={props.throwMethodAssigner.closeGroupPopCaller}
          triggerdeclineAdding={props.throwMethodAssigner.declineAddingCaller}
        />
      </RACModalCard>
      <RACModalCard
        isOpen={props.throwModalController.breakPackageCtrl}
        maxWidth="xs"
        closeIcon={true}
        onClose={() =>
          props.throwMethodAssigner.closeModalCaller('breakPackageCtrl')
        }
        borderRadius={radiusProvider}
      >
        <ModalBuilder
          displayData={t('Do you want to break the Price Tag ?')}
          methodController="delete package"
          requiredButton="Pair"
          triggeracceptBreakPackage={
            props.throwMethodAssigner.acceptBreakPackageCaller
          }
          triggerdeclineBreakPackage={
            props.throwMethodAssigner.declineBreakPackageCaller
          }
        />
      </RACModalCard>

      <RACModalCard
        isOpen={props.throwModalController.RateTermController}
        maxWidth="xs"
        closeIcon={false}
        borderRadius={radiusProvider}
      >
        <ModalBuilder
          displayData={t('Price Exception')}
          methodController="price exception"
          requiredButton="Single"
          pricingExceptionData={props.throwPricingException}
          triggercloseRateTermPopUp={
            props.throwMethodAssigner.closeRateTermPopUpCaller
          }
        />
      </RACModalCard>
      <RACModalCard
        isOpen={props.throwModalController.packageExceptionController}
        maxWidth="xs"
        closeIcon={false}
        borderRadius={radiusProvider}
      >
        <ModalBuilder
          displayData={t(
            'Items are not a valid component for this package type'
          )}
          methodController="package exception"
          requiredButton="Single"
          triggerclosepackageExceptionController={
            props.throwMethodAssigner.closepackageExceptionControllerCaller
          }
        />
      </RACModalCard>
      <RACModalCard
        isOpen={props.throwModalController.PackageExceptionPopup}
        maxWidth="xs"
        closeIcon={false}
        borderRadius={radiusProvider}
      >
        <ModalBuilder
          displayData={props.throwFormException}
          methodController="package criteria"
          requiredButton="Single"
          triggeracceptPackageCriteria={
            props.throwMethodAssigner.acceptPackageCriteriaCaller
          }
        />
      </RACModalCard>
      <RACModalCard
        isOpen={props.throwModalController.itemPricingFail}
        maxWidth="xs"
        closeIcon={false}
        borderRadius={radiusProvider}
      >
        <ModalBuilder
          displayData={props.throwPriceExceptionMessage}
          methodController="item pricing fail"
          requiredButton="Single"
          triggeracceptPricingFail={
            props.throwMethodAssigner.acceptPricingFailCaller
          }
        />
      </RACModalCard>

      <RACModalCard
        isOpen={props.throwModalController.reservedExceptionController}
        maxWidth="xs"
        closeIcon={false}
        borderRadius={radiusProvider}
      >
        <ModalBuilder
          displayData={t(
            'The selected inventory is reserved, Please choose other inventory in Rent Ready status.'
          )}
          methodController="reserved controlling"
          requiredButton="Single"
          triggercloseReservedPopup={
            props.throwMethodAssigner.closeReservedPopup
          }
        />
      </RACModalCard>
    </>
  );
};

export default ModalContainer;
